import React from 'react';

const summaryRowStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.375rem',
  minWidth: 0,
  width: 'auto',
  maxWidth: '100%',
  overflow: 'hidden',
};

const summaryTextStyle = {
  display: 'block',
  flex: '0 1 auto',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

/**
 * Shows a compact role summary for group Assigned Roles pickers.
 */
const RoleSelectionSummary = ({
  names = [],
  placeholder = '—',
  className = '',
  countClassName = 'assess-mod-groups-selection-count-badge',
  totalCount = null,
  allSelectedLabel = 'All selected',
  summaryMode = 'default',
  itemLabel = 'roles',
}) => {
  if (!names.length) {
    return <span className={className}>{placeholder}</span>;
  }

  if (summaryMode === 'default') {
    if (names.length === 1) {
      return <span className={className}>{names[0]}</span>;
    }
    return (
      <span className={`assess-mod-groups-selection-summary ${className}`.trim()} style={summaryRowStyle}>
        <span className="assess-mod-groups-selection-summary__name truncate" style={summaryTextStyle}>
          {names[0]}
        </span>
        <span className={countClassName} style={{ marginLeft: '0.25rem' }}>
          +{names.length - 1}
        </span>
      </span>
    );
  }

  const normalizedTotalCount = Number(totalCount);
  const isAllSelected =
    Number.isFinite(normalizedTotalCount) &&
    normalizedTotalCount > 0 &&
    names.length >= normalizedTotalCount;

  if (isAllSelected) {
    return (
      <span className={`assess-mod-groups-selection-summary ${className}`.trim()} style={summaryRowStyle}>
        <span className="assess-mod-groups-selection-summary__name truncate" style={summaryTextStyle}>
          {allSelectedLabel}
        </span>
        <span className={countClassName}>
          ({normalizedTotalCount})
        </span>
      </span>
    );
  }

  if (summaryMode === 'count') {
    if (names.length === 1) {
      return <span className={className}>{names[0]}</span>;
    }
    return (
      <span className={`assess-mod-groups-selection-summary ${className}`.trim()} style={summaryRowStyle}>
        <span
          className="assess-mod-groups-selection-summary__name truncate"
          style={summaryTextStyle}
        >
          {`${names.length} ${itemLabel} selected`}
        </span>
      </span>
    );
  }

  if (names.length === 1) {
    return <span className={className}>{names[0]}</span>;
  }

  if (names.length === 2) {
    return (
      <span className={`assess-mod-groups-selection-summary ${className}`.trim()} style={summaryRowStyle}>
        <span className="assess-mod-groups-selection-summary__name truncate" style={summaryTextStyle}>
          {`${names[0]}, ${names[1]}`}
        </span>
      </span>
    );
  }

  return (
    <span className={`assess-mod-groups-selection-summary ${className}`.trim()} style={summaryRowStyle}>
      <span
        className="assess-mod-groups-selection-summary__name truncate"
        style={summaryTextStyle}
      >
        {`${names.length} roles selected`}
      </span>
    </span>
  );
};

export default RoleSelectionSummary;
